import { createRootRoute, Outlet } from '@tanstack/react-router'
import { AppProvider } from '../contexts/AppContext'
import Navigation from '../components/Navigation'

export const Route = createRootRoute({
  component: () => (
    <AppProvider>
      <div className="min-h-screen bg-white">
        <Navigation />
        <main>
          <Outlet />
        </main>
      </div>
    </AppProvider>
  ),
})